<ui-page-container size="small">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica utente' : 'Aggiungi utente') | translate }}
    </mat-card-title>
    <mat-card-content>
      <form
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <mat-form-field class="input-expanse">
          <input
            type="text"
            name="username"
            matInput
            formControlName="username"
            [placeholder]="'Username' | translate">
        </mat-form-field>
        <ng-container *ngIf="entityControls?.username?.touched">
          <mat-error
            *ngIf="entityControls?.username?.hasError('required')"
            class="message-error">
            {{ 'Username obblogatorio' | translate }}
          </mat-error>
        </ng-container>

        <mat-form-field class="input-expanse">
          <input
            class="input-expanse"
            type="email"
            name="email"
            matInput
            formControlName="email"
            [placeholder]="'Email' | translate">
        </mat-form-field>
        <ng-container *ngIf="entityControls?.email?.touched">
          <mat-error
            class="message-error"
            *ngIf="entityControls?.email?.hasError('required')">
            {{ 'Email obbligatoria' | translate }}
          </mat-error>
          <mat-error
            class="message-error"
            *ngIf="entityControls?.email?.hasError('email')">
            {{ 'Formato email non valido' | translate }}
          </mat-error>
        </ng-container>

        <mat-form-field class="input-expanse">
          <input
            type="text"
            name="firstname"
            matInput
            formControlName="firstName"
            [placeholder]="'Nome' | translate">
        </mat-form-field>
        <ng-container *ngIf="entityControls?.firstName?.touched">
          <mat-error
            *ngIf="entityControls?.username?.hasError('required')"
            class="message-error">
            {{ 'Nome obbligatorio' | translate }}
          </mat-error>
        </ng-container>

        <mat-form-field class="input-expanse">
          <input
            type="text"
            name="lastname"
            matInput
            formControlName="lastName"
            [placeholder]="'Cognome' | translate">
        </mat-form-field>
        <ng-container *ngIf="entityControls?.firstName?.touched">
          <mat-error
            *ngIf="entityControls?.username?.hasError('required')"
            class="message-error">
            {{ 'Cognome obbligatorio' | translate }}
          </mat-error>
        </ng-container>

        <mat-form-field class="input-expanse">
          <input
            type="password"
            name="password"
            matInput
            [formControl]="passwordControl"
            [placeholder]="'Password' | translate">
        </mat-form-field>
        <ng-container *ngIf="passwordControl?.touched">
          <mat-error
            *ngIf="passwordControl?.hasError('required')"
            class="message-error">
            {{ 'Password obbligatoria' | translate }}
          </mat-error>
        </ng-container>

        <div class="roles-container">
          <h2>{{ 'Gestione ruoli' | translate }}</h2>
          <div>
            <mat-radio-group formControlName="role">
              <mat-radio-button
                class="role-item"
                *ngFor="let r of roles$ | async; let i = index"
                [value]="r.id">
                {{ r.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <ng-container *ngIf="entityControls?.role?.touched">
          <mat-error
            *ngIf="entityControls?.role?.hasError('required')"
            class="message-error">
            {{ 'Ruolo obbligatorio' | translate }}
          </mat-error>
        </ng-container>

        <div class="user-actions">
          <button
            mat-raised-button
            color="primary"
            type="submit">
            {{ (entityId ? 'Salva' : 'Crea') | translate }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ui-page-container>
